import { Icon, IconProps } from "../";

export const StarOnIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        d="M100,1449.27 L104.15,1451.78 C104.91,1452.24 105.84,1451.56 105.64,1450.7 L104.54,1445.98 L108.21,1442.8 C108.88,1442.22 108.52,1441.12 107.64,1441.05 L102.81,1440.64 L100.92,1436.18 C100.58,1435.37 99.42,1435.37 99.08,1436.18 L97.19,1440.63 L92.36,1441.04 C91.48,1441.11 91.12,1442.21 91.79,1442.79 L95.46,1445.97 L94.36,1450.69 C94.16,1451.55 95.09,1452.23 95.85,1451.77 L100,1449.27 Z"
        transform="translate(-88 -1432)"
        fillRule="evenodd"
      />
    </Icon>
  );
};
